export default "__VITE_ASSET__Bh5hR8He__"